<template>
  <div>
    <div class="enter">
      <!-- 1.信电查入口 -->
      <div class="right">
        <img
          style="height: 320px; width: 100%; overflow: hidden"
          src="../../assets/reportImg.png"
          alt=""
        />
      </div>
    </div>
    <!-- 导航 -->
    <navigate :daohangshuju="daohangshuju" />

    <div class="text1 contentCss">
      <p>
        商务信用评价“卡尺”是度量集团外部企业商务信用的产品。通过科学、标准的评价体系对涉电力领域市场主体在电力生产、输送、销售、应用及服务等环节的经营发展过程中执行国家相关法律、法规、产业政策、市场规则，参与社会活动、承担社会责任、履行相关合约的意愿、能力和表现进行综合评价，并得出确定结果的行为；是综合社会各类信用信息对涉电力领域市场主体等信用状况客观反映并进行分类管理的信用管理手段。为供应商企业开展招标审核、集采入库提供标准工具；为企业供应商分类管理提供评价依据；辅助企业实现供应商动态监管、金融信贷等。<el-link
          type="primary"
          :underline="false"
          href="https://www.cecdlzx.com/dlzx/#/login"
          target="_blank"
          ><span class="licxCss">立即查询>></span></el-link
        >
        <a href="#report"><span class="licxCss ljsqCss">立即授权</span></a>
      </p>
    </div>
    <div class="product contentCss">
      <div class="text">
        <h4>面向用户</h4>
        <p>
          发电企业、电网企业、电力施工企业、电力设计企业、电力行业供应商、电能服务企业、售电企业、电力用户、银行保险等金融机构。
        </p>
      </div>
      <div class="text">
        <h4>应用场景</h4>
        <p>为电力集团及下属企业的电力供应商分类管理提供依据。</p>
        <p>为供应商企业开展招标审核、集采入库提供标准工具。</p>
        <p>辅助企业实现供应商动态监管、金融信贷等。</p>
      </div>
      <div class="text">
        <h4>卡尺依据全维度商务信用评价指标体系</h4>
        <p>
          专业管理评价指标——包括安全环保管理、技术能力、人力资源管理、质量管理等。
        </p>
        <p>
          经营管理评价指标——包括企业经营状况、资产运营能力、盈利能力、偿债能力、发展能力等。
        </p>
        <p>
          信用管理评价指标——包括管理层信用、社会责任、信用记录、招投标管理、履约管理等。
        </p>
      </div>
      <div class="text">
        <h4>信用报告</h4>
        <p>
          评价报告具有批量自动化、内容个性化、格式多样化的显著特点，一键触达，快捷且全面的掌握企业信用状况。
        </p>
        <p>批量自动化——突破人工瓶颈，大批量报告标准化生成。</p>
        <p>内容个性化——按需选择内容维度，定制报告一键生成</p>
        <p>格式多样化——支持word、pdf、excel多种文件格式。</p>
      </div>

      <div id="report" class="text">
        <h4>认证授权</h4>
        <p>
          商务信用评价报告是依赖企业的税票数据才能正常评价，因此首先需要企业做电子税务局的认证授权，目前我们支持PC端和移动端两种方式，具体如下：
        </p>
        <div style="text-align: center">
          <iframe
            style="width: 1240px; height: calc(100vh - 195px)"
            src="https://www.cecdlzx.com/dlzx/#/dataAcquisition"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import xdcPng from '@/assets/xdc.png'
import ckPng from '@/assets/logo.png'
import srcImg from '@/assets/xdc1.png'
import HoverImage from "@/components/HoverImage/index"
// 导航组件
import navigate from '@/components/navigate'
export default {
  name: 'vuecomponent',
  components: {
    HoverImage,
    navigate
  },
  data () {
    return {
      xdcPng: xdcPng,
      ckPng,
      searchInput: '',
      bannerList: [
        {
          id: 1,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/257f8ab88f9445b98f9c2826c3203e45.png',
          url: "https://www.cecdlzx.com/owms/#/home"
        },
        {
          id: 2,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/576e0a8c10f1459797aced9ca904efd1.png',
          url: "https://www.cecdlzx.com/dlzx/#/electric"
        },
        {
          id: 3,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/77b7d0be5ebc43ad94854b7863386d4c.png',
          url: "https://www.cecdlzx.com/dlzx/#/login"
        },
      ],
      key: "value",
      srcImg,
      daohangshuju: '商务信用评价',

    }
  },
  methods: {
    func () {

    }
  },
  mounted () {
    let daohangArr = [
      { key: 'product', value: '产品简介' },
      { key: 'xdc', value: '信电查' },
      { key: 'report', value: '商务信用评价' },
      { key: 'monitor', value: '风险监测' },
      { key: 'cecIndex', value: '电力指数' },
      { key: 'contact', value: '联系我们' },
    ]
    this.activeMenu = window.location.hash.split("#")[1].split("/")[1]
    daohangArr.forEach(item => {
      if (item.key == this.activeMenu) {
        this.daohangshuju = item.value
      }
    })

  },
}
</script>

<style lang="less" scoped>
.bannerImg {
  height: 260px;
}

.daohang {
  padding-bottom: 10px;
  font-size: 20px;
  color: #00489d;
  border-bottom: 1px solid #005ba3;
}
.text1 {
  position: relative;
  padding: 0 10px;
  .ljsqCss {
    margin-left: 15px;
    position: absolute;
  }
}
.product {
  margin-bottom: 60px;
  .h3Text {
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    color: rgba(58, 58, 74, 1);
    margin-top: 30px;
  }
  .text {
    // margin: 15px;
    padding: 10px;
    h4 {
      color: #005ba3;
      margin-top: 10px;
      margin-bottom: 10px;
      font-size: 16px;
    }
    p {
      margin: 0 0 5px;
      line-height: 24px;
    }
  }
}

.partner {
  // margin: 10px 0;

  .title {
    text-align: center;
    position: relative;

    p {
      font-size: 48px;
      font-weight: bold;
      color: rgba(153, 154, 155, 0.3);
    }

    h2 {
      font-size: 36px;
      position: absolute;
      margin: 0;
      left: 45%;
      top: 35px;
    }
  }

  .list {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    span {
      width: 150px;
      height: 60px;
    }
  }
}

.enter {
  overflow: hidden;
  position: relative;
  // padding: 10px;
  width: 100%;
  height: 350px;
  .right {
    width: 100%;
  }
  .last {
    margin-left: 80px;
    width: 100%;
    position: absolute;
    top: 260px;
    .smallBox {
      font-size: 16px;
      width: 180px;
      height: 50px;
      color: #fff;
      border-radius: 5px;
      padding: 10px;
      text-align: center;
      line-height: 45px;
      height: 60px;
      border: 2px solid #53aee7;
      background: #53aee7;
      box-shadow: 0 1px 1px #53aee7, 0 2px 2px #53aee7, 0 3px 3px #53aee7,
        0 4px 4px #53aee7, 0 5px 5px #53aee7;
      transform-origin: 50% 50%;
      /* 设置过渡动画 */
      transition: all 1s;
    }
  }
}
.smallBox:hover {
  /* 鼠标移动上去后  */
  transform: scale(1.2, 1.2);
}
.xdcSearch {
  margin: 10px auto;
  height: 45px;
  line-height: 45px;
  border-radius: 5px;
  text-align: center;
  border: 1px solid #53aee7;
  width: 150px;
}

.sqcj {
  color: #005ba3;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 16px;
}
</style>
